export const AmplitudeEvents = {
  MARKETING_PAGE_VISITED: "MARKETING_PAGE_VISITED",
  HOMEPAGE_CTA_CLICKED: "HOMEPAGE_CTA_CLICKED",
  SIGNIN_BTN_CLICKED: "SIGNIN_BTN_CLICKED",
  PRICING_PAGE_VISITED: "PRICING_PAGE_VISITED",
  ABOUT_US_VISITED: "ABOUT_US_VISITED" 
}
